import axiosInstance from "../../../../../axiosInstance";
import {
  error,
  info,
  success,
  warning,
} from "../../../../../store/notification/actions";

// Add supplier to database.

export async function GetSupplierEdiCode() {
  return await axiosInstance
    .get("/ancillary/supplier/getSupplierEdiCode")
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data.map((obj,index) => ({
          id: index,
          optionname: obj.suppliercode,
        }));
      } else {
        return [];
      }
    })
    .catch((err) => {});
}

export async function GetAllSupplierData() {
  return await axiosInstance
    .get("/ancillary/supplier/getAllSupplierData")
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data;
      } else {
        return [];
      }
    })
    .catch((err) => {});
}

export async function GetSupplierEdiCodeWithoutManupulation() {
  return await axiosInstance
    .get("/ancillary/supplier/getSupplierEdiCode")
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data;
      } else {
        return [];
      }
    })
    .catch((err) => {});
}

export async function addSupplier(data) {
  info("Adding new Supplier...");
  if (data != null) {
    return await axiosInstance
      .post("/ancillary/supplier/addSupplier", {
        store_id: data.storeid,
        supplier_name: data.supplier_name,
        aliasname: data.aliasname,
        address: data.address,
        contactno: data.contactno,
        contactperson: data.contactperson,
        contactmail: data.contactmail,
        accountno: data.accountno,
        supplier_code : data.supplierEdiCode,
        supplier_type : data.supplier_type
      })
      .then((response) => {
        if (response.data.status === "success") {
          success("Supplier Created successfully");
          return { message: "", hasError: false, data: response.data.data };
        } else {
          error(response.data.error[0].message);
          if(response.data.error[0].message === "Supplier Already Exists"){
            return getSuppliers(data.storeid)
          }
          else{
            return {
              message: response.data.error[0].message,
              hasError: true,
              data: "",
            };
          }
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        if(err.response.data.error[0].message === "Supplier Already Exists"){
          return getSuppliers(data.storeid)
        }
        else{
          return {
            message: err.response.data.error[0].message,
            hasError: true,
            data: "",
          };
        }
      });
  } else {
    return { message: "Internal error occurred", hasError: true, data: "" };
  }
}

// Edit supplier

export async function editSupplier(data) {
  info("Saving Supplier changes...");
  if (data != null) {
    return await axiosInstance
      .post("/ancillary/supplier/editSupplier", {
        store_id: data.storeid,
        supplier_id: data.supplier_id,
        supplier_name: data.supplier_name,
        aliasname: data.aliasname,
        address: data.address,
        contactno: data.contactno,
        contactperson: data.contactperson,
        contactmail: data.contactmail,
        accountno: data.accountno,
        supplier_code : data.supplierEdiCode,
        supplier_type : data.supplier_type
      })
      .then((response) => {
        if (response.data.status === "success") {
          success("Supplier saved successfully");
          return { message: "", hasError: false, data: response.data.data };
        } else {
          error(response.data.error[0].message);
          if(response.data.error[0].message === "Supplier Already Exists"){
            return getSuppliers(data.storeid)
          }
          else{
            return {
              message: response.data.error[0].message,
              hasError: true,
              data: "",
            };
          }
        }
      })
      .catch((err) => {

        error(err.response.data.error[0].message);
        if(err.response.data.error[0].message === "Supplier Already Exists"){
          return getSuppliers(data.storeid)
        }
        else{
          return {
            message: err.response.data.error[0].message,
            hasError: true,
            data: "",
          };
        }
      });
  } else {
    return { message: "Internal error occurred", hasError: true, data: "" };
  }
}

// delete supplier

export const deleteSupplier = (data) => {
  info("Deleting Supplier...");
  return axiosInstance
    .post("/ancillary/supplier/deleteSupplier", {
      store_id: data.store_id,
      supplier_id: data.supplier_id,
    })
    .then((res) => {
      if (res.data.status === "success") {
        success("Supplier Deleted successfully");
        return { message: "", hasError: false, data: res.data.data };
      }
    })
    .catch((err) => {
      error(err.response.data.error[0].message);
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
};

// get suppliers

export const getSuppliers = (storeid) => {
  info("Loading Suppliers...");
  if (storeid) {
    return axiosInstance
      .post(`/ancillary/supplier/getSuppliers`, { store_id: storeid })
      .then((res) => {
        if (res.data.status === "success" && res.data.data.length > 0) {
          success("Loaded Suppliers Successfully!!!");
          return { message: "", hasError: false, data: res.data.data };
        } else {
          warning('No records found !!!')
          return { message: "No records found.", hasError: true, data: "" };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });
  }
};

export const getSuppliersForEDI = (storeid) => {
  info("Loading Suppliers...");
  if (storeid) {
    return axiosInstance
      .post(`/ancillary/supplier/getSuppliersForEDI`, { store_id: storeid })
      .then((res) => {
        if (res.data.status === "success" && res.data.data.length > 0) {
          success("Loaded Suppliers Successfully!!!");
          return { message: "", hasError: false, data: res.data.data };
        } else {
          warning('No records found !!!')
          return { message: "No records found.", hasError: true, data: "" };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });
  }
};
